export default {
    '1d-diagram5': {
        'diagram-task': 'Type your answer in the white box.<br>Then click the ‘reveal’ button to see how it compares to the correct answer',
      'diagram-description': `<li>Creating narratives is a powerful way to pass on information</li>
                                <li>Listing facts imposes a heavy burden on memory</li>
                                <li>Relating them as a plot turns them into a single piece of information</li>
                                <li>The plot can be easily communicated to others</li>`,
        'fixed-answer1': 'Creating narratives is a powerful way to pass on information',
        'fixed-answer2': 'Listing facts imposes a heavy burden on memory',
        'fixed-answer3': 'Relating them as a plot turns them into a single piece of information',
        'fixed-answer4': 'The plot can be easily communicated to others'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/1/1d/diagram5/i18n/en.js